/* global LOCALE */

import AuthService from '../AuthService'
import { startLoading, setErrorAndStopLoading } from '../apps/components/Notifications'
import { messagesCommon } from '../i18n/translations-common'
const m = messagesCommon[LOCALE]

let elements2HideOnly = document.querySelectorAll('.hide-when-logged-in')
let becomeMemberButtons = document.querySelectorAll('.register-button')
let signInButtons = document.querySelectorAll('.sign-in-button')

window.addEventListener('DOMContentLoaded', () => {
  elements2HideOnly = document.querySelectorAll('.hide-when-logged-in')
  becomeMemberButtons = document.querySelectorAll('.register-button')
  signInButtons = document.querySelectorAll('.sign-in-button')

  becomeMemberButtons.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      try {
        startLoading('authStatus')
        AuthService.redirectSignup()
      } catch (e) {
        setErrorAndStopLoading(e)
      }
    })
  })

  signInButtons.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      try {
        startLoading('authStatus')
        AuthService.signIn()
      } catch (e) {
        setErrorAndStopLoading(e)
      }
    })
  })
})

AuthService.on('ended', e => {
  if (AuthService.isAuthenticated) {
    [...elements2HideOnly, ...becomeMemberButtons, ...signInButtons].forEach(el => {
      el.classList.add('is-hidden')
    })

    if (document.body.classList.contains('layout-loyalty-list')) {
      const button = document.createElement('a')
      button.classList.add('button', 'button--primary')
      button.href = 'profile'
      button.textContent = m.authStatus.myProfile
      document.querySelector('.hero__buttons')?.appendChild(button)
    }
  } else {
    [...becomeMemberButtons, ...signInButtons].forEach(el => {
      el.classList.remove('is-hidden')
    })
  }
})
